// Calculate how many stars they got
// If they solved it in 1 minute or less, they get 5 stars
// If they solved it in 2 minutes or less, they get 4 stars, etc.
// If they solved it in 5 minutes or more, they get 1 star
export default function calculateScore(time: number) {
	let starCount = 0
	if (time <= 60) starCount = 5
	else if (time <= 120) starCount = 4
	else if (time <= 180) starCount = 3
	else if (time <= 240) starCount = 2
	else starCount = 1
	return starCount
}
